import { PromptAnnotateDataSidebarContent } from "./Annotate/PromptAnnotateDataSidebarContent";

export const PromptSidebarContent = () => {
    // Text prompting is now the only mode, no review step needed
    return <PromptAnnotateDataSidebarContent />;
};
